import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/svg/angle-arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-1f2dc570"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content content-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("Any questions? "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "Contact us")
], -1))
const _hoisted_3 = { class: "inputs" }
const _hoisted_4 = { class: "inputBlock" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inputTitle" }, "First name", -1))
const _hoisted_6 = { class: "inputBlock" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inputTitle" }, "Last name", -1))
const _hoisted_8 = { class: "inputBlock fullWidth" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inputTitle" }, "Email", -1))
const _hoisted_10 = { class: "inputBlock fullWidth" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inputTitle" }, "Message", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button fullWidth" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "buttonText" }, "submit"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0,
    alt: "achieve"
  })
], -1))

import VueScrollTo from 'vue-scrollto'
import { inject, reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactMobile',
  setup(__props) {

const scrollTo = VueScrollTo.scrollTo

const data = reactive({
  name: '',
  lastName: '',
  email: '',
  message: ''
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.name) = $event)),
          placeholder: "Enter your first name"
        }, null, 512), [
          [_vModelText, data.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.lastName) = $event)),
          placeholder: "Enter your last name"
        }, null, 512), [
          [_vModelText, data.lastName]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.email) = $event)),
          placeholder: "Enter your email"
        }, null, 512), [
          [_vModelText, data.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("textarea", {
          class: "input",
          rows: "5",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.message) = $event)),
          placeholder: "Type your message here"
        }, null, 512), [
          [_vModelText, data.message]
        ])
      ]),
      _hoisted_12
    ])
  ]))
}
}

})